export default __webpack_public_path__ + "static/media/brazil.90a19fa6.svg";